import io from 'socket.io-client'

const createNoopSocket = () => {
	const socket = {
		requested_channels: {},
		join() {},
		leave() {},
		joinIndividualChannel() {},
		leaveIndividualChannel() {},
		on() {
			return socket
		},
		emit() {
			return socket
		},
	}

	return socket
}

export default class Socket {
	constructor() {
		if (global.testing) return createNoopSocket()

		if (!window.socket) {
			// Initialize the socket
			if (window.location.host.includes('127.0.0.1') || window.location.host.includes('localhost'))
				window.socket = io.connect('http://localhost:8080')
			else window.socket = io.connect('https://d3b7qkjqmdbxc0.cloudfront.net')

			window.socket.requested_channels = {}
			window.socket.join = this.join
			window.socket.leave = this.leave
			window.socket.joinIndividualChannel = this.joinIndividualChannel
			window.socket.leaveIndividualChannel = this.leaveIndividualChannel

			window.socket.on('connect', () => {
				console.info('Connected')

				// axios({
				// 	method: 'GET',
				// 	url: `${process.env.API_URL}/api/v1/users/current_user_id`,
				// })
				// 	.then((response) => {
				// 		window.socket.emit('join', response.data)
				// 	})
				// 	.catch((err) => {
				// 		console.error(err)
				// 	})
			})
		}

		return window.socket
	}

	join(channels, context) {
		const requested_channels = Array.isArray(channels) ? channels : [channels]

		requested_channels.forEach((c) => this.joinIndividualChannel(c, context))
	}

	leave(channels, context) {
		const requested_channels = Array.isArray(channels) ? channels : [channels]

		requested_channels.forEach((c) => this.leaveIndividualChannel(c, context))
	}

	joinIndividualChannel(channel, context) {
		// Initialize the channel's requesters set
		if (!this.requested_channels[channel]) this.requested_channels[channel] = new Set()

		// Add the context to the channel's requesters set
		this.requested_channels[channel].add(context)

		// Join the channel generously
		window.socket.emit('join', channel)
	}

	leaveIndividualChannel(channel, context) {
		if (this.requested_channels[channel]) {
			// Remove the context from the requesters set
			this.requested_channels[channel].delete(context)

			// Only leave the channel if it's the last requester context in the set
			if (this.requested_channels[channel].size === 0) window.socket.emit('leave', channel)
		}
	}
}
